import axios from "axios";
import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import swal from "sweetalert";
import "./Settings.css";
const Security = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  //set eye icon
  const [oldPasswordIcon, setOldPasswordIcon] = useState(false);
  const [newPasswordIcon, setNewPasswordIcon] = useState(false);
  const [confirmPasswordIcon, setConfirmPasswordIcon] = useState(false);

  const [infoBuffer, setInfoBuffer] = useState(false);

  const securityHandle = (e) => {
    e.preventDefault();
    setInfoBuffer(true);
    const formData = new FormData();

    formData.append("oldPassword", oldPassword);
    formData.append("newPassword", newPassword);

    if (confirmPassword == newPassword) {
       if(newPassword.length>4)
       {
         axios.post(`/api/user/password/changes`, formData).then((res) => {
           setInfoBuffer(false);
           if (res.data.status === 200) {
             if (res.data.message == "User Updated Password") {
               swal("Operation Successful", "Password Changed Successfully!", "success");
             } else {
               swal("Operation Successful", res.data.message, "success");
             }
           } else {
             if (res.data.message == "Old password not match") {
               swal("Sorry", "The old password you entered is incorrect. Please try again.", "warning");
             } else {
               swal("Sorry", res.data.message, "warning");
             }
           }
         });
       }else{
         swal("Sorry", "Password must be at least 5 characters long.", "warning");
         setInfoBuffer(false);
       }
    } else {
      swal("Sorry", "New Password and Confirm Password do not match", "warning");
      setInfoBuffer(false);
    }
  };

  return (
    <>
      <form onSubmit={securityHandle}>
        {" "}
        <div className="row col-md-12 mx-md-2 justify-content-center">
          <h5 className="text-light text-left">Security Information</h5>
          <div className="under-line-x mb-3 mt-1"></div>
        </div>
        <center>
          <div className="row col-sm-12 col-md-12 mx-md-3 col-lg-10 justify-content-center">
            <div className="d-flex col-md-4 col-lg-4 mb-3 text-light justify-content-md-between">
              <div>Current Password</div>
              <div>&nbsp;:</div>
            </div>
            <div className="col-sm-12 col-md-8 mb-3 password-container">
              <input
                type={oldPasswordIcon ? "text" : "password"}
                className="from-control w-100 custom-con-input form-control-sm "
                placeholder="Enter old password"
                onChange={(e) => setOldPassword(e.target.value)}
              />
              <i
                className={`eye oldPassEye fa-solid ${
                  !oldPasswordIcon ? "fa-eye-slash" : "fa-eye"
                }`}
                onClick={() => setOldPasswordIcon(!oldPasswordIcon)}
              ></i>
            </div>
            <div className="d-flex col-md-4 col-lg-4 mb-3 text-light justify-content-md-between">
              <div>New Password</div>
              <div>&nbsp;:</div>
            </div>
            <div className="col-sm-12 col-md-8 mb-3 password-container">
              <input
                type={newPasswordIcon ? "text" : "password"}
                className="from-control w-100 custom-con-input form-control-sm "
                placeholder="New password"
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <i
                className={`eye newPassEye fa-solid ${
                  !newPasswordIcon ? "fa-eye-slash" : "fa-eye"
                }`}
                onClick={() => setNewPasswordIcon(!newPasswordIcon)}
              ></i>
            </div>
            <div className="d-flex col-md-4 col-lg-4 mb-3 text-light justify-content-md-between">
              <div>Confirm Password</div>
              <div>&nbsp;:</div>
            </div>
            <div className="col-sm-12 col-md-8 mb-3 password-container">
              <input
                type={confirmPasswordIcon ? "text" : "password"}
                className="from-control w-100 custom-con-input form-control-sm "
                placeholder="Confirm password"
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <i
                className={`eye confirmPassEye fa-solid ${
                  !confirmPasswordIcon ? "fa-eye-slash" : "fa-eye"
                }`}
                onClick={() => setConfirmPasswordIcon(!confirmPasswordIcon)}
              ></i>
            </div>
          </div>
          <div className="d-flex col-md-4 col-lg-4 mb-3 text-light justify-content-md-between">
            <div></div>
            <div></div>
          </div>
          <div className="col-sm-12 col-md-8 mb-3 justify-content-center my-3 ">
            <div className="col-md-4">
              <button className="btn BTnInfo w-100 fw-bold" type="submit">
                {infoBuffer ? (
                  <>
                    <i className="fas fa-spinner fa-pulse"></i>&nbsp;
                  </>
                ) : (
                  <></>
                )}
                Save
              </button>
            </div>
          </div>
        </center>
      </form>
    </>
  );
};

export default Security;
